import { routes } from "@constants/routes";
import { ArrowRightIcon, BackLineIcon, handleApiRequest } from "@cpj-ai/panel-npm-package";
import {
  AuthAccountOrganizationJobPositionStatusChoices,
  GetJobPositionByIdQuery,
  UpdateJobPositionStatusMutation,
  UpdateJobPositionStatusMutationVariables,
  useUpdateJobPositionStatusMutation,
} from "@graphql/generated";
import { Button, Card } from "@heroui/react";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { GeneralInformation } from "../../../components/JobPositionGeneralInformation";

interface IGeneralInformationAndActionsProps {
  handleBackToEdit: () => void;
  jobPositionData?: GetJobPositionByIdQuery | null;
}

const GeneralInformationAndActions = ({ handleBackToEdit, jobPositionData }: IGeneralInformationAndActionsProps) => {
  const { id } = useParams();
  const [updateJobPositionStatus] = useUpdateJobPositionStatusMutation();
  const navigate = useNavigate();

  const handleChangeStatusAndNext = useCallback(async () => {
    if (!id) {
      toast.error("No job post ID found");
      return;
    }

    await handleApiRequest<UpdateJobPositionStatusMutation, UpdateJobPositionStatusMutationVariables>({
      apiFunction: updateJobPositionStatus,
      variables: {
        id,
        status: AuthAccountOrganizationJobPositionStatusChoices.SUBMITTED,
      },
      componentName: "RequirementsStepContent",
      actionName: "updateJobPositionStatus",
      onSuccess: () => {
        navigate(routes.jobPositions.view.replace(":id", id));
      },
      successMessage: "Job post published successfully",
      fallbackErrorMessage: "Failed to publish job post",
      extraErrorContext: {
        jobPositionId: id,
      },
    });
  }, [id, updateJobPositionStatus, navigate]);

  return (
    <div className="w-full md:w-4/12">
      <Card className="py-6 px-4" shadow="sm">
        <GeneralInformation jobPositionData={jobPositionData} />
      </Card>
      <div className="flex flex-col gap-2 md:gap-4 mt-6">
        <Button
          color="success"
          onPress={handleChangeStatusAndNext}
          endContent={<ArrowRightIcon width={24} height={24} stroke="#fff" className="mt-1.5" />}
          className="rounded-xl"
        >
          Job Post Registration
        </Button>
        <Button
          variant="bordered"
          startContent={<BackLineIcon width={24} height={24} fill="#71717A" className="mt-1.5" />}
          className="rounded-xl border-2 border-zinc-500 text-zinc-500"
          onPress={handleBackToEdit}
        >
          Back and edit
        </Button>
      </div>
    </div>
  );
};

export default GeneralInformationAndActions;
